import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "teamMemberCardRef",
      staticClass: "team-member-card d-flex flex-column gr-4",
    },
    [
      _c(
        "div",
        { staticClass: "d-flex gc-4" },
        [
          _c(VImg, {
            staticClass: "flex-grow-0 rounded-circle",
            attrs: {
              "lazy-src": "/static/_v1/pd/pictures/stubs/person-photo.png",
              alt: `${_setup.transDynamic(
                _vm.teamMember,
                `first_name,${_setup.language},${_setup.needTranslate}`
              )} ${_setup.transDynamic(
                _vm.teamMember,
                `last_name,${_setup.language},${_setup.needTranslate}`
              )} ${_setup.transDynamic(
                _vm.teamMember,
                `position,${_setup.language},${_setup.needTranslate}`
              )}`,
              src: _vm.teamMember.photo.url,
              width: "40",
              height: "40",
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c("p", { staticClass: "text-body-1 text--text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _setup.transDynamic(
                      _vm.teamMember,
                      `first_name,${_setup.language},${_setup.needTranslate}`
                    )
                  ) +
                  "\n        " +
                  _vm._s(
                    _setup.transDynamic(
                      _vm.teamMember,
                      `last_name,${_setup.language},${_setup.needTranslate}`
                    )
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text-body-2 text-info--text" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _setup.transDynamic(
                      _vm.teamMember,
                      `position,${_setup.language},${_setup.needTranslate}`
                    )
                  ) +
                  "\n      "
              ),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", {
        ref: "descriptionHtmlRef",
        staticClass: "team-member-card__html text-body-1 text--text",
        class: _setup.isExpandedDescription
          ? "team-member-card__html--expanded"
          : "",
        domProps: {
          innerHTML: _vm._s(
            _setup.transDynamic(
              _vm.teamMember,
              `description,${_setup.language},${_setup.needTranslate}`
            ) /* eslint-disable-line vue/no-v-html */
          ),
        },
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "text-body-1 align-self-start cursor-pointer",
          class: _setup.isExpandedDescription ? "text--text" : "primary--text",
          attrs: { type: "button" },
          on: { click: _setup.handleClickExpandDescription },
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _setup.isExpandedDescription
                  ? _setup.t("Скрыть", _setup.options)
                  : _setup.t("Показать всё", _setup.options)
              ) +
              "\n  "
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }